export default __webpack_public_path__ + "static/media/TX Comm Envir Qual.9ca07da8.png";